import React, { useId } from 'react';

export default function AgentWorkbenchIcon() {
  const gradientId = useId().replace(/:/g, '');

  return (
    <svg width="20" height="20" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
      <path d="M15.125 7.7915H6.87496C5.10305 7.7915 3.66663 9.22792 3.66663 10.9998V15.5832C3.66663 17.3551 5.10305 18.7915 6.87496 18.7915H15.125C16.8969 18.7915 18.3333 17.3551 18.3333 15.5832V10.9998C18.3333 9.22792 16.8969 7.7915 15.125 7.7915Z" stroke={`url(#${gradientId}-paint0)`} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M11 7.79167V4.125" stroke={`url(#${gradientId}-paint1)`} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M11 4.30814C11.6582 4.30814 12.1917 3.77461 12.1917 3.11647C12.1917 2.45833 11.6582 1.9248 11 1.9248C10.3419 1.9248 9.80835 2.45833 9.80835 3.11647C9.80835 3.77461 10.3419 4.30814 11 4.30814Z" fill={`url(#${gradientId}-paint2)`}/>
      <path d="M3.66672 11.9165H2.01672" stroke={`url(#${gradientId}-paint3)`} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M18.3334 11.9165H19.9834" stroke={`url(#${gradientId}-paint4)`} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M8.25001 13.9334C8.95877 13.9334 9.53334 13.3588 9.53334 12.65C9.53334 11.9413 8.95877 11.3667 8.25001 11.3667C7.54124 11.3667 6.96667 11.9413 6.96667 12.65C6.96667 13.3588 7.54124 13.9334 8.25001 13.9334Z" fill={`url(#${gradientId}-paint5)`}/>
      <path d="M13.75 13.9334C14.4588 13.9334 15.0333 13.3588 15.0333 12.65C15.0333 11.9413 14.4588 11.3667 13.75 11.3667C13.0412 11.3667 12.4667 11.9413 12.4667 12.65C12.4667 13.3588 13.0412 13.9334 13.75 13.9334Z" fill={`url(#${gradientId}-paint6)`}/>
      <path d="M8.70837 15.8584H13.2917" stroke={`url(#${gradientId}-paint7)`} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <defs>
        <linearGradient id={`${gradientId}-paint0`} x1="1.83329" y1="1.83317" x2="20.1666" y2="20.1665" gradientUnits="userSpaceOnUse">
          <stop stopColor="#5B6CFF"/>
          <stop offset="0.5" stopColor="#9B45E8"/>
          <stop offset="1" stopColor="#FF3DA6"/>
        </linearGradient>
        <linearGradient id={`${gradientId}-paint1`} x1="1" y1="1.83333" x2="19.2642" y2="21.7579" gradientUnits="userSpaceOnUse">
          <stop stopColor="#5B6CFF"/>
          <stop offset="0.5" stopColor="#9B45E8"/>
          <stop offset="1" stopColor="#FF3DA6"/>
        </linearGradient>
        <linearGradient id={`${gradientId}-paint2`} x1="1.83335" y1="1.83314" x2="20.1667" y2="20.1665" gradientUnits="userSpaceOnUse">
          <stop stopColor="#5B6CFF"/>
          <stop offset="0.5" stopColor="#9B45E8"/>
          <stop offset="1" stopColor="#FF3DA6"/>
        </linearGradient>
        <linearGradient id={`${gradientId}-paint3`} x1="1.83339" y1="0.916504" x2="21.7579" y2="19.1807" gradientUnits="userSpaceOnUse">
          <stop stopColor="#5B6CFF"/>
          <stop offset="0.5" stopColor="#9B45E8"/>
          <stop offset="1" stopColor="#FF3DA6"/>
        </linearGradient>
        <linearGradient id={`${gradientId}-paint4`} x1="1.83338" y1="0.916504" x2="21.7579" y2="19.1806" gradientUnits="userSpaceOnUse">
          <stop stopColor="#5B6CFF"/>
          <stop offset="0.5" stopColor="#9B45E8"/>
          <stop offset="1" stopColor="#FF3DA6"/>
        </linearGradient>
        <linearGradient id={`${gradientId}-paint5`} x1="1.83334" y1="1.83337" x2="20.1667" y2="20.1667" gradientUnits="userSpaceOnUse">
          <stop stopColor="#5B6CFF"/>
          <stop offset="0.5" stopColor="#9B45E8"/>
          <stop offset="1" stopColor="#FF3DA6"/>
        </linearGradient>
        <linearGradient id={`${gradientId}-paint6`} x1="1.83334" y1="1.83337" x2="20.1667" y2="20.1667" gradientUnits="userSpaceOnUse">
          <stop stopColor="#5B6CFF"/>
          <stop offset="0.5" stopColor="#9B45E8"/>
          <stop offset="1" stopColor="#FF3DA6"/>
        </linearGradient>
        <linearGradient id={`${gradientId}-paint7`} x1="1.83337" y1="0.558399" x2="21.7579" y2="18.8226" gradientUnits="userSpaceOnUse">
          <stop stopColor="#5B6CFF"/>
          <stop offset="0.5" stopColor="#9B45E8"/>
          <stop offset="1" stopColor="#FF3DA6"/>
        </linearGradient>
      </defs>
    </svg>
  );
}
